import React, {useEffect, useState} from 'react'
import {getCustomers} from "../../../services/api/apiCustomers"
import CustomersTable from "./datas/CustomersTable"
import CustomerFilters from "./filters/CustomerFilters"
import UseDebounce from "../../shared/UseDebounce"
import {Pagination} from "antd"
import CustomersProvider from "./CustomersProvider"
import CustomerForm from "./shared/CustomerForm"
import parseToken from "../../../helpers/parseToken"
import FilterInput from "./filters/FilterInput"

function CustomersPage() {
    const decodeToken = parseToken()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [listCustomers, setListCustomers] = useState([])

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')

    const [limit, setLimit] = useState(20)
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)

    const [showFilter, setShowFilter] = useState(false)

    const _onToggleFilter = () => {
        setShowFilter(!showFilter)
    }

    const _handleChangeInput = (e) => {
        const {name, value} = e.target

        if (name === 'name') {
            setName(value)
            setPage(1)
        } else if (name === 'email') {
            setEmail(value)
            setPage(1)
        } else {
            setPhone(value)
            setPage(1)
        }
    }

    const _onChangeLimit = (page, pageSize) => {
        setLimit(pageSize)
        setPage(pageSize !== limit ? 1 : page)
    }

    const _fetchListCustomer = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                name,
                email,
                phone,
                limit,
                page
            }

            const response = await getCustomers(payload, decodeToken.sub)

            const {success, data, error_message, totalRecord} = response

            if (parseInt(success) !== 1) {
                setLoading(false)
                return setError(error_message)
            }

            setLoading(false)
            setListCustomers(data)
            setTotal(totalRecord)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    function itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a href={() => false}>Previous</a>
        }
        if (type === 'next') {
            return <a href={() => false}>Next</a>
        }
        return originalElement
    }

    const debouncedSearchName = UseDebounce(name, 1000)
    const debouncedSearchEmail = UseDebounce(email, 1000)
    const debouncedSearchPhone = UseDebounce(phone, 1000)

    useEffect(() => {
        _fetchListCustomer()
        // eslint-disable-next-line
    }, [debouncedSearchName, debouncedSearchEmail, debouncedSearchPhone, limit, page])

    return (
        <CustomersProvider getCustomers={_fetchListCustomer}>
            <div className="CustomersPage">
                <div className='PageHeading'>
                    {/* eslint-disable-next-line jsx-a11y/heading-has-content */}
                    <h1 className="PageTitle"></h1>
                    <div className="PageFilterTop">
                        <div className="FiltersOpen" onClick={_onToggleFilter}>
                            <span className="material-icons Filter">filter_list</span>
                            <label>Bộ lọc</label>
                        </div>
                        <FilterInput
                            label=""
                            name="name"
                            placeholder="Tìm kiếm khách hàng"
                            value={name}
                            onChangeInput={_handleChangeInput}
                        />
                        <CustomerForm item={{}} createBy={decodeToken.sub} label="Thêm khách hàng" type="add"/>
                    </div>

                </div>

                {
                    showFilter && <div className="Filter">
                        <CustomerFilters
                            name={name}
                            phone={phone}
                            email={email}
                            onChangeInput={_handleChangeInput}
                        />
                    </div>
                }

                <div className="ContentPage">
                    <CustomersTable loading={loading} page={page} limit={limit} error={error}
                                    listCustomers={listCustomers}/>

                    <div className="FooterTable">
                        <div className="Total">Total {total} items</div>
                        <Pagination
                            className="PaginationCustom"
                            showSizeChanger={false}
                            total={total}
                            current={page}
                            pageSize={limit}
                            itemRender={itemRender}
                            onChange={_onChangeLimit}
                        />
                    </div>
                </div>
            </div>
        </CustomersProvider>
    )
}

export default CustomersPage
